module.exports = __webpack_public_path__ + "img/gutters.85964b46.svg";